import type { ComponentProps } from 'react'
import { History, MailOpen } from 'lucide-react'
import { ROLE_PIECES, type WebModule } from '../core/index.js'
import { AdminsPage } from './admin/AdminsPage.js'
import { FacilityAdministratorList } from './admin/FacilityAdministratorList.js'
import { OperatorList } from './admin/OperatorList.js'
import { SignInsPage } from './admin/SignInsPage.js'
import { InvitationsPage } from './admin/InvitationsPage.js'

type Api = ComponentProps<typeof OperatorList>['api'] &
  ComponentProps<typeof FacilityAdministratorList>['api'] &
  ComponentProps<typeof AdminsPage>['api'] &
  ComponentProps<typeof SignInsPage>['api'] &
  ComponentProps<typeof InvitationsPage>['api']

/** What the accounts module contributes to the shells: every kind of login the admin area manages, and the root's sign-in history. */
export const accountsWebModule: WebModule<Api> = {
  name: 'accounts',
  adminPages: [
    { path: '/admin/operators', label: 'Operators', title: 'All Operators', icon: ROLE_PIECES.operator, group: 'accounts', page: ({ api }) => <OperatorList api={api} /> },
    {
      path: '/admin/facility-administrators',
      label: 'Facility Admins',
      title: 'All Facility Administrators',
      icon: ROLE_PIECES.facility_administrator,
      group: 'accounts',
      page: ({ api }) => <FacilityAdministratorList api={api} />,
    },
    {
      path: '/admin/admins',
      label: 'Admins',
      title: 'SeeWhoCares Admins',
      icon: ROLE_PIECES.admin,
      group: 'accounts',
      rootOnly: true,
      page: ({ api, session, onPasswordRotated, onNameChanged }) => <AdminsPage api={api} session={session} onPasswordRotated={onPasswordRotated} onNameChanged={onNameChanged} />,
    },
    // Everyone waiting on an invitation, for any admin (invitations plan section 5).
    { path: '/admin/invitations', label: 'Invitations', title: 'Invitations waiting', icon: MailOpen, group: 'system', page: ({ api }) => <InvitationsPage api={api} /> },
    // How the system is used: the root's alone.
    { path: '/admin/sign-ins', label: 'Sign-ins', title: 'Sign-in History', icon: History, group: 'system', rootOnly: true, page: ({ api }) => <SignInsPage api={api} /> },
  ],
}
